import {
  CLEAR_SUGGESTIONS,
  FETCH_SUGGESTIONS,
  FETCH_SUGGESTIONS_FULFILLED,
  FETCH_SUGGESTIONS_REJECTED,
} from 'b2b-apps/shop/catalog/redux/suggestions/actionTypes';
import {
  ClearSuggestionsAction,
  FetchSuggestionsAction,
  FetchSuggestionsFulfilledAction,
  FetchSuggestionsRejectedAction,
  SuggestionsType,
} from 'b2b-apps/shop/catalog/redux/suggestions/types';

const clearSuggestions = (): ClearSuggestionsAction => ({
  type: CLEAR_SUGGESTIONS,
});

const fetchSuggestions = (query: string): FetchSuggestionsAction => ({
  type: FETCH_SUGGESTIONS,
  payload: {
    query,
  },
});

const fetchSuggestionsFulfilled = (
  response: SuggestionsType,
): FetchSuggestionsFulfilledAction => ({
  type: FETCH_SUGGESTIONS_FULFILLED,
  payload: {
    data: response,
  },
});

const fetchSuggestionsRejected = (
  error: ErrorType,
): FetchSuggestionsRejectedAction => ({
  type: FETCH_SUGGESTIONS_REJECTED,
  payload: {
    error,
  },
});

export {
  clearSuggestions,
  fetchSuggestions,
  fetchSuggestionsFulfilled,
  fetchSuggestionsRejected,
};
